module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "html-editor"
  }, [_c('div', {
    staticClass: "html-toolbar"
  }, [_c('div', {
    staticClass: "tool-group"
  }, [_c('select', {
    domProps: {
      "value": _vm.style
    },
    on: {
      "input": function($event) {
        _vm.setStyle($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "h1"
    }
  }, [_vm._v("Heading 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h2"
    }
  }, [_vm._v("Heading 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal")])])]), _vm._v(" "), _c('div', {
    staticClass: "tool-group"
  }, [_c('button', {
    class: {
      active: _vm.isSelectionBold
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.runCommand('toggle-bold')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bold"
  })]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.isSelectionItalic
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.runCommand('toggle-italic')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-italic"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tool-group"
  }, [_c('button', {
    class: {
      active: _vm.isSelectionUl
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.runCommand('toggle-ul')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  })]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.isSelectionOl
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.runCommand('toggle-ol')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tool-group"
  }, [_c('button', {
    class: {
      active: _vm.linkMenuEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLinkMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.imageMenuEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleImageMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-image"
  })]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.videoMenuEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleVideoMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  })]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.fileMenuEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleFileMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  })])]), _vm._v(" "), (_vm.allowEmoji) ? _c('div', {
    staticClass: "tool-group"
  }, [_c('button', {
    class: {
      active: _vm.emojiMenuEnabled
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleEmojiMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o"
  })])]) : _vm._e(), _vm._v(" "), (_vm.showToolbarExtension) ? _c('div', {
    staticClass: "toolbar-extension"
  }, [(_vm.linkMenuEnabled) ? _c('form', {
    staticClass: "link-menu",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.isSelectionLink ? _vm.removeLink() : _vm.createLink()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkMenuUrl),
      expression: "linkMenuUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "URL",
      "disabled": _vm.isSelectionLink
    },
    domProps: {
      "value": (_vm.linkMenuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkMenuUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkMenuText),
      expression: "linkMenuText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Text (optional)",
      "disabled": !_vm.isSelectionEmpty
    },
    domProps: {
      "value": (_vm.linkMenuText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linkMenuText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isSelectionLink) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Remove Link"
    }
  }) : _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add link",
      "disabled": !_vm.canCreateLink,
      "title": _vm.linkMenuStatus
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imageMenuEnabled) ? _c('form', {
    staticClass: "image-menu",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createImage($event)
      }
    }
  }, [_c('div', {
    staticClass: "mode radio-input"
  }, [_c('label', {
    class: {
      active: _vm.imageMenuMode === 'file'
    }
  }, [_vm._v("\n                        File\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageMenuMode),
      expression: "imageMenuMode"
    }],
    attrs: {
      "type": "radio",
      "value": "file",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.imageMenuMode, "file")
    },
    on: {
      "__c": function($event) {
        _vm.imageMenuMode = "file"
      }
    }
  })]), _vm._v(" "), _c('label', {
    class: {
      active: _vm.imageMenuMode === 'url'
    }
  }, [_vm._v("\n                        URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageMenuMode),
      expression: "imageMenuMode"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.imageMenuMode, "url")
    },
    on: {
      "__c": function($event) {
        _vm.imageMenuMode = "url"
      }
    }
  })])]), _vm._v(" "), (_vm.imageMenuMode === 'file') ? _c('label', {
    staticClass: "file-input"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "accept": _vm.allowedImageTypes.join(',')
    },
    on: {
      "change": function($event) {
        _vm.imageMenuFiles = Array.from($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-btn"
  }, [_vm._v("Choose files")]), _vm._v(" "), (_vm.imageMenuFiles.length > 0) ? _c('div', {
    staticClass: "filename",
    attrs: {
      "title": _vm.imageMenuFileNames
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.imageMenuFileNames) + "\n                    ")]) : _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n                        No file selected\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.imageMenuMode === 'url') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageMenuUrl),
      expression: "imageMenuUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.imageMenuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageMenuUrl = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageMenuCaption),
      expression: "imageMenuCaption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Caption (optional)"
    },
    domProps: {
      "value": (_vm.imageMenuCaption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageMenuCaption = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add images",
      "disabled": !_vm.canCreateImage,
      "title": _vm.imageMenuStatus
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.videoMenuEnabled) ? _c('form', {
    staticClass: "video-menu",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createVideo($event)
      }
    }
  }, [_c('div', {
    staticClass: "mode radio-input"
  }, [_c('label', {
    class: {
      active: _vm.videoMenuMode === 'file'
    }
  }, [_vm._v("\n                        File\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoMenuMode),
      expression: "videoMenuMode"
    }],
    attrs: {
      "type": "radio",
      "value": "file",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.videoMenuMode, "file")
    },
    on: {
      "__c": function($event) {
        _vm.videoMenuMode = "file"
      }
    }
  })]), _vm._v(" "), _c('label', {
    class: {
      active: _vm.videoMenuMode === 'url'
    }
  }, [_vm._v("\n                        URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoMenuMode),
      expression: "videoMenuMode"
    }],
    attrs: {
      "type": "radio",
      "value": "url"
    },
    domProps: {
      "checked": _vm._q(_vm.videoMenuMode, "url")
    },
    on: {
      "__c": function($event) {
        _vm.videoMenuMode = "url"
      }
    }
  })])]), _vm._v(" "), (_vm.videoMenuMode === 'file') ? _c('label', {
    staticClass: "file-input"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "accept": _vm.allowedVideoTypes.join(',')
    },
    on: {
      "change": function($event) {
        _vm.videoMenuFiles = Array.from($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-btn"
  }, [_vm._v("Choose files")]), _vm._v(" "), (_vm.videoMenuFiles.length > 0) ? _c('div', {
    staticClass: "filename",
    attrs: {
      "title": _vm.videoMenuFileNames
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.videoMenuFileNames) + "\n                    ")]) : _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n                        No file selected\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.videoMenuMode === 'url') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoMenuUrl),
      expression: "videoMenuUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "YouTube or Vimeo URL"
    },
    domProps: {
      "value": (_vm.videoMenuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoMenuUrl = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoMenuCaption),
      expression: "videoMenuCaption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Caption (optional)"
    },
    domProps: {
      "value": (_vm.videoMenuCaption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoMenuCaption = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add videos",
      "disabled": !_vm.canCreateVideo,
      "title": _vm.videoMenuStatus
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.fileMenuEnabled) ? _c('form', {
    staticClass: "file-menu",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createFiles($event)
      }
    }
  }, [_c('label', {
    staticClass: "file-input"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "multiple"
    },
    on: {
      "change": function($event) {
        _vm.fileMenuFiles = Array.from($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-btn"
  }, [_vm._v("Choose files")]), _vm._v(" "), (_vm.fileMenuFiles.length > 0) ? _c('div', {
    staticClass: "filename",
    attrs: {
      "title": _vm.fileMenuFileNames
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.fileMenuFileNames) + "\n                    ")]) : _c('div', {
    staticClass: "filename"
  }, [_vm._v("\n                        No file selected\n                    ")])]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add files",
      "disabled": !_vm.canCreateFiles,
      "title": _vm.fileMenuStatus
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.emojiMenuEnabled) ? _c('EmojiPicker', {
    ref: "emojiPicker",
    on: {
      "pick": function($event) {
        _vm.createEmoji($event)
      }
    }
  }) : _vm._e()], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b25a2c10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/html-editor/index.vue
// module id = 2090
// module chunks = 2